<span class="countdown-display">{{ minutes() | number: '2.0-0' }}:{{ seconds() | number: '2.0-0' }}</span>
